import { createSlice } from "@reduxjs/toolkit";

const gameSlice = createSlice({
  name: "game",
  initialState: {
    activeScreen: 'welcome',
    activeTheme: '',
    activeModal: '',
    gameRestarted: false,
    gameWon: false,
    clockRunning: false,
    startClock: false,
    finalGameTime: '',
    themes: {
      theme1: {
        background: 'red',
        textColor: 'white',
        title: 'Theme 1',
        thumb: 'theme-1-thumb',
        icons: [
          'Final_Approved_Bingo_Icons__Cow.png',
          'Final_Approved_Bingo_Icons__Deer.png',
          'Final_Approved_Bingo_Icons__DoNotEnter.png',
          'Final_Approved_Bingo_Icons__DumpTruck.png',
          'Final_Approved_Bingo_Icons__EmergencyPullOff.png',
          'Final_Approved_Bingo_Icons__KeepRightExceptToPass.png',
          'Final_Approved_Bingo_Icons__NoUTurn.png',
          'Final_Approved_Bingo_Icons__OneWay.png',
          'Final_Approved_Bingo_Icons__OrangeCone.png',
          'Final_Approved_Bingo_Icons__Overpass.png',
          'Final_Approved_Bingo_Icons__OverturnedTruck.png',
          'Final_Approved_Bingo_Icons__PATurnpike.png',
          'Final_Approved_Bingo_Icons__RedBarn.png',
          'Final_Approved_Bingo_Icons__RedCar.png',
          'Final_Approved_Bingo_Icons__RoadWorkAhead.png',
          'Final_Approved_Bingo_Icons__ServicePlaza.png',
          'Final_Approved_Bingo_Icons__SpeedLimit70.png',
          'Final_Approved_Bingo_Icons__StateTrooper.png',
          'Final_Approved_Bingo_Icons__StayInLane.png',
          'Final_Approved_Bingo_Icons__Tunnel.png',
          'Final_Approved_Bingo_Icons__WorkZoneSpeedLimit55.png',
          'Final_Approved_Bingo_Icons__WorkZoneTurnOnHeadlights.png',
          'Final_Approved_Bingo_Icons__WrongWay.png',
          'Final_Approved_Bingo_Icons__YellowTruck.png',
          'Final_Approved_Bingo_Icons__Yield.png',
          'Final_Approved_Bingo_Icons__ActiveSpeedLimitPhotoEnforced.png',
          'Final_Approved_Bingo_Icons__ActiveWorkZoneWhenFlashing.png',
          'Final_Approved_Bingo_Icons__Arrow.png',
          'Final_Approved_Bingo_Icons__BuckleUp.png',
          'Final_Approved_Bingo_Icons__Chevron.png',
          'Final_Approved_Bingo_Icons__ConstructionTwoArrows.png',
          'Final_Approved_Bingo_Icons__ConstructionZone.png',
          'TwoMore_Approved_Bingo_Icons__AllLanesEZPAss.png',
          'TwoMore_Approved_Bingo_Icons__Tunnel.png'

        ]
      },
      theme2: {
        background: 'blue',
        textColor: 'white',
        title: 'Theme 2',
        thumb: 'theme-2-thumb',
        icons: [
          'Final_Approved_Bingo_Icons__Cow.png',
          'Final_Approved_Bingo_Icons__Deer.png',
          'Final_Approved_Bingo_Icons__DoNotEnter.png',
          'Final_Approved_Bingo_Icons__DumpTruck.png',
          'Final_Approved_Bingo_Icons__EmergencyPullOff.png',
          'Final_Approved_Bingo_Icons__KeepRightExceptToPass.png',
          'Final_Approved_Bingo_Icons__NoUTurn.png',
          'Final_Approved_Bingo_Icons__OneWay.png',
          'Final_Approved_Bingo_Icons__OrangeCone.png',
          'Final_Approved_Bingo_Icons__Overpass.png',
          'Final_Approved_Bingo_Icons__OverturnedTruck.png',
          'Final_Approved_Bingo_Icons__PATurnpike.png',
          'Final_Approved_Bingo_Icons__RedBarn.png',
          'Final_Approved_Bingo_Icons__RedCar.png',
          'Final_Approved_Bingo_Icons__RoadWorkAhead.png',
          'Final_Approved_Bingo_Icons__ServicePlaza.png',
          'Final_Approved_Bingo_Icons__SpeedLimit70.png',
          'Final_Approved_Bingo_Icons__StateTrooper.png',
          'Final_Approved_Bingo_Icons__StayInLane.png',
          'Final_Approved_Bingo_Icons__Tunnel.png',
          'Final_Approved_Bingo_Icons__WorkZoneSpeedLimit55.png',
          'Final_Approved_Bingo_Icons__WorkZoneTurnOnHeadlights.png',
          'Final_Approved_Bingo_Icons__WrongWay.png',
          'Final_Approved_Bingo_Icons__YellowTruck.png',
          'Final_Approved_Bingo_Icons__Yield.png',
          'Final_Approved_Bingo_Icons__ActiveSpeedLimitPhotoEnforced.png',
          'Final_Approved_Bingo_Icons__ActiveWorkZoneWhenFlashing.png',
          'Final_Approved_Bingo_Icons__Arrow.png',
          'Final_Approved_Bingo_Icons__BuckleUp.png',
          'Final_Approved_Bingo_Icons__Chevron.png',
          'Final_Approved_Bingo_Icons__ConstructionTwoArrows.png',
          'Final_Approved_Bingo_Icons__ConstructionZone.png',
          'TwoMore_Approved_Bingo_Icons__AllLanesEZPAss.png',
          'TwoMore_Approved_Bingo_Icons__Tunnel.png'
        ]
      },
      theme3: {
        background: 'green',
        textColor: 'black',
        title: 'Theme 3',
        thumb: 'theme-3-thumb',
        icons: [
          'Final_Approved_Bingo_Icons__Cow.png',
          'Final_Approved_Bingo_Icons__Deer.png',
          'Final_Approved_Bingo_Icons__DoNotEnter.png',
          'Final_Approved_Bingo_Icons__DumpTruck.png',
          'Final_Approved_Bingo_Icons__EmergencyPullOff.png',
          'Final_Approved_Bingo_Icons__KeepRightExceptToPass.png',
          'Final_Approved_Bingo_Icons__NoUTurn.png',
          'Final_Approved_Bingo_Icons__OneWay.png',
          'Final_Approved_Bingo_Icons__OrangeCone.png',
          'Final_Approved_Bingo_Icons__Overpass.png',
          'Final_Approved_Bingo_Icons__OverturnedTruck.png',
          'Final_Approved_Bingo_Icons__PATurnpike.png',
          'Final_Approved_Bingo_Icons__RedBarn.png',
          'Final_Approved_Bingo_Icons__RedCar.png',
          'Final_Approved_Bingo_Icons__RoadWorkAhead.png',
          'Final_Approved_Bingo_Icons__ServicePlaza.png',
          'Final_Approved_Bingo_Icons__SpeedLimit70.png',
          'Final_Approved_Bingo_Icons__StateTrooper.png',
          'Final_Approved_Bingo_Icons__StayInLane.png',
          'Final_Approved_Bingo_Icons__Tunnel.png',
          'Final_Approved_Bingo_Icons__WorkZoneSpeedLimit55.png',
          'Final_Approved_Bingo_Icons__WorkZoneTurnOnHeadlights.png',
          'Final_Approved_Bingo_Icons__WrongWay.png',
          'Final_Approved_Bingo_Icons__YellowTruck.png',
          'Final_Approved_Bingo_Icons__Yield.png',
          'Final_Approved_Bingo_Icons__ActiveSpeedLimitPhotoEnforced.png',
          'Final_Approved_Bingo_Icons__ActiveWorkZoneWhenFlashing.png',
          'Final_Approved_Bingo_Icons__Arrow.png',
          'Final_Approved_Bingo_Icons__BuckleUp.png',
          'Final_Approved_Bingo_Icons__Chevron.png',
          'Final_Approved_Bingo_Icons__ConstructionTwoArrows.png',
          'Final_Approved_Bingo_Icons__ConstructionZone.png',
          'TwoMore_Approved_Bingo_Icons__AllLanesEZPAss.png',
          'TwoMore_Approved_Bingo_Icons__Tunnel.png'
        ]
      },
      theme4: {
        background: 'orange',
        textColor: 'black',
        title: 'Theme 4',
        thumb: 'theme-4-thumb',
        icons: [
          'Final_Approved_Bingo_Icons__Cow.png',
          'Final_Approved_Bingo_Icons__Deer.png',
          'Final_Approved_Bingo_Icons__DoNotEnter.png',
          'Final_Approved_Bingo_Icons__DumpTruck.png',
          'Final_Approved_Bingo_Icons__EmergencyPullOff.png',
          'Final_Approved_Bingo_Icons__KeepRightExceptToPass.png',
          'Final_Approved_Bingo_Icons__NoUTurn.png',
          'Final_Approved_Bingo_Icons__OneWay.png',
          'Final_Approved_Bingo_Icons__OrangeCone.png',
          'Final_Approved_Bingo_Icons__Overpass.png',
          'Final_Approved_Bingo_Icons__OverturnedTruck.png',
          'Final_Approved_Bingo_Icons__PATurnpike.png',
          'Final_Approved_Bingo_Icons__RedBarn.png',
          'Final_Approved_Bingo_Icons__RedCar.png',
          'Final_Approved_Bingo_Icons__RoadWorkAhead.png',
          'Final_Approved_Bingo_Icons__ServicePlaza.png',
          'Final_Approved_Bingo_Icons__SpeedLimit70.png',
          'Final_Approved_Bingo_Icons__StateTrooper.png',
          'Final_Approved_Bingo_Icons__StayInLane.png',
          'Final_Approved_Bingo_Icons__Tunnel.png',
          'Final_Approved_Bingo_Icons__WorkZoneSpeedLimit55.png',
          'Final_Approved_Bingo_Icons__WorkZoneTurnOnHeadlights.png',
          'Final_Approved_Bingo_Icons__WrongWay.png',
          'Final_Approved_Bingo_Icons__YellowTruck.png',
          'Final_Approved_Bingo_Icons__Yield.png',
          'Final_Approved_Bingo_Icons__ActiveSpeedLimitPhotoEnforced.png',
          'Final_Approved_Bingo_Icons__ActiveWorkZoneWhenFlashing.png',
          'Final_Approved_Bingo_Icons__Arrow.png',
          'Final_Approved_Bingo_Icons__BuckleUp.png',
          'Final_Approved_Bingo_Icons__Chevron.png',
          'Final_Approved_Bingo_Icons__ConstructionTwoArrows.png',
          'Final_Approved_Bingo_Icons__ConstructionZone.png',
          'TwoMore_Approved_Bingo_Icons__AllLanesEZPAss.png',
          'TwoMore_Approved_Bingo_Icons__Tunnel.png'
        ]
      },
      theme5: {
        background: 'purple',
        textColor: 'white',
        title: 'Theme 5',
        thumb: 'theme-5-thumb',
        icons: [
          'Final_Approved_Bingo_Icons__Cow.png',
          'Final_Approved_Bingo_Icons__Deer.png',
          'Final_Approved_Bingo_Icons__DoNotEnter.png',
          'Final_Approved_Bingo_Icons__DumpTruck.png',
          'Final_Approved_Bingo_Icons__EmergencyPullOff.png',
          'Final_Approved_Bingo_Icons__KeepRightExceptToPass.png',
          'Final_Approved_Bingo_Icons__NoUTurn.png',
          'Final_Approved_Bingo_Icons__OneWay.png',
          'Final_Approved_Bingo_Icons__OrangeCone.png',
          'Final_Approved_Bingo_Icons__Overpass.png',
          'Final_Approved_Bingo_Icons__OverturnedTruck.png',
          'Final_Approved_Bingo_Icons__PATurnpike.png',
          'Final_Approved_Bingo_Icons__RedBarn.png',
          'Final_Approved_Bingo_Icons__RedCar.png',
          'Final_Approved_Bingo_Icons__RoadWorkAhead.png',
          'Final_Approved_Bingo_Icons__ServicePlaza.png',
          'Final_Approved_Bingo_Icons__SpeedLimit70.png',
          'Final_Approved_Bingo_Icons__StateTrooper.png',
          'Final_Approved_Bingo_Icons__StayInLane.png',
          'Final_Approved_Bingo_Icons__Tunnel.png',
          'Final_Approved_Bingo_Icons__WorkZoneSpeedLimit55.png',
          'Final_Approved_Bingo_Icons__WorkZoneTurnOnHeadlights.png',
          'Final_Approved_Bingo_Icons__WrongWay.png',
          'Final_Approved_Bingo_Icons__YellowTruck.png',
          'Final_Approved_Bingo_Icons__Yield.png',
          'Final_Approved_Bingo_Icons__ActiveSpeedLimitPhotoEnforced.png',
          'Final_Approved_Bingo_Icons__ActiveWorkZoneWhenFlashing.png',
          'Final_Approved_Bingo_Icons__Arrow.png',
          'Final_Approved_Bingo_Icons__BuckleUp.png',
          'Final_Approved_Bingo_Icons__Chevron.png',
          'Final_Approved_Bingo_Icons__ConstructionTwoArrows.png',
          'Final_Approved_Bingo_Icons__ConstructionZone.png',
          'TwoMore_Approved_Bingo_Icons__AllLanesEZPAss.png',
          'TwoMore_Approved_Bingo_Icons__Tunnel.png'
        ]
      },
      theme6: {
        background: 'yellow',
        textColor: 'black',
        title: 'Theme 6',
        thumb: 'theme-6-thumb',
        icons: [
          'Final_Approved_Bingo_Icons__Cow.png',
          'Final_Approved_Bingo_Icons__Deer.png',
          'Final_Approved_Bingo_Icons__DoNotEnter.png',
          'Final_Approved_Bingo_Icons__DumpTruck.png',
          'Final_Approved_Bingo_Icons__EmergencyPullOff.png',
          'Final_Approved_Bingo_Icons__KeepRightExceptToPass.png',
          'Final_Approved_Bingo_Icons__NoUTurn.png',
          'Final_Approved_Bingo_Icons__OneWay.png',
          'Final_Approved_Bingo_Icons__OrangeCone.png',
          'Final_Approved_Bingo_Icons__Overpass.png',
          'Final_Approved_Bingo_Icons__OverturnedTruck.png',
          'Final_Approved_Bingo_Icons__PATurnpike.png',
          'Final_Approved_Bingo_Icons__RedBarn.png',
          'Final_Approved_Bingo_Icons__RedCar.png',
          'Final_Approved_Bingo_Icons__RoadWorkAhead.png',
          'Final_Approved_Bingo_Icons__ServicePlaza.png',
          'Final_Approved_Bingo_Icons__SpeedLimit70.png',
          'Final_Approved_Bingo_Icons__StateTrooper.png',
          'Final_Approved_Bingo_Icons__StayInLane.png',
          'Final_Approved_Bingo_Icons__Tunnel.png',
          'Final_Approved_Bingo_Icons__WorkZoneSpeedLimit55.png',
          'Final_Approved_Bingo_Icons__WorkZoneTurnOnHeadlights.png',
          'Final_Approved_Bingo_Icons__WrongWay.png',
          'Final_Approved_Bingo_Icons__YellowTruck.png',
          'Final_Approved_Bingo_Icons__Yield.png',
          'Final_Approved_Bingo_Icons__ActiveSpeedLimitPhotoEnforced.png',
          'Final_Approved_Bingo_Icons__ActiveWorkZoneWhenFlashing.png',
          'Final_Approved_Bingo_Icons__Arrow.png',
          'Final_Approved_Bingo_Icons__BuckleUp.png',
          'Final_Approved_Bingo_Icons__Chevron.png',
          'Final_Approved_Bingo_Icons__ConstructionTwoArrows.png',
          'Final_Approved_Bingo_Icons__ConstructionZone.png',
          'TwoMore_Approved_Bingo_Icons__AllLanesEZPAss.png',
          'TwoMore_Approved_Bingo_Icons__Tunnel.png'
        ]
      },
    }
  },
  reducers: {
    setScreen: (state, action) => {
      state.activeScreen = action.payload;
    },
    setTheme: (state, action) => {
      state.activeTheme = action.payload;
      state.activeScreen = 'game';
    },
    setActiveModal: (state, action) => {
      state.activeModal = action.payload;
    },
    setGameRestarted: (state, action) => {
      state.gameRestarted = action.payload;
      if(action.payload) {
        state.startClock = false;
        state.clockStarted = false;
      }
    },
    setStartClock: (state, action) => {
      state.startClock = action.payload;
    },
    setClockRunning: (state, action) => {
      state.clockRunning = action.payload;
    },
    setGameWon: (state, action) => {
      state.gameWon = action.payload;
    },
    setFinalGameTime: (state, action) => {
      state.finalGameTime = action.payload;
    },
  },
});

export const gameActions = gameSlice.actions;

export default gameSlice;
